import React, { FC, memo } from 'react';
import styles from './assets/footer.module.scss';
import classNames from 'classnames';

const Footer: FC = memo(() => <footer className={classNames(styles.footer, 'main-footer')} />);

export default Footer;
